// Baked in at webpack build time via DefinePlugin (see theia-electron/webpack.config.js).
const isEnabledBuildFlag = (value: unknown): boolean => value === true || value === 'true';

// Keep the internal build flag as a build-time switch.
export const isInternalBuild = (): boolean => isEnabledBuildFlag(process.env.THEIA_INTERNAL_BUILD);

// Keep the Online Preview auth bypass as a build-time switch.
export const isE2EAuthBypassBuild = (): boolean => isEnabledBuildFlag(process.env.THEIA_E2E_AUTH_BYPASS);

// Matches `theia build --mode development` vs `--mode production`.
export const isDevelopmentBuild = (): boolean => process.env.THEIA_BUILD_MODE === 'development';

// Keep the dev tools enabled flag as a build-time switch.
export const isDevToolsEnabled = (): boolean => isInternalBuild() || isDevelopmentBuild();
